export default __webpack_public_path__ + "static/media/profile.314fb261.jpg";